// This wrapper is used to wrap the analytics object, to limit exposed methods and provide our own load method.
// Once everything is loaded we replace window.analytics with instance of Analytics which is returned from AnalyticsBrowser.load().

class AnalyticsWrapper {
    analytics;
    analyticsLoader;
    onError;

    constructor(analytics, analyticsLoader, onError) {
        this.analytics = analytics;
        this.analyticsLoader = analyticsLoader;
        this.onError = onError;
    }

    page(name, properties, options) {
        this.analytics
            .page(name, properties, options)
            .catch((err) => this.onError({ message: `@vp/tracking: page failed. ${err.message}` }));
    }

    track(name, properties, options) {
        this.analytics
            .track(name, properties, options)
            .catch((err) => this.onError({ message: `@vp/tracking: track failed. ${err.message}` }));
    }

    trackLink(element, eventName, properties) {
        this.analytics
            .trackLink(element, eventName, properties)
            .catch((err) => this.onError({ message: `@vp/tracking: trackLink failed. ${err.message}` }));
    }

    identify(userId, traits, options) {
        this.analytics
            .identify(userId, traits, options)
            .catch((err) => this.onError({ message: `@vp/tracking: identify failed. ${err.message}` }));
    }

    reset() {
        this.analytics.reset().catch((err) => this.onError({ message: `@vp/tracking: reset failed. ${err.message}` }));
    }

    ready(callback) {
        this.analytics
            .ready(callback)
            .catch((err) => this.onError({ message: `@vp/tracking: ready failed. ${err.message}` }));
    }

    debug(debug) {
        this.analytics
            .debug(debug)
            .catch((err) => this.onError({ message: `@vp/tracking: debug failed. ${err.message}` }));
    }

    original() {
        return this.analytics;
    }

    load(writeKey) {
        this.analyticsLoader(writeKey);
    }
}

module.exports = AnalyticsWrapper;
